module.exports = __webpack_public_path__ + "img/thumb_ocorrencias_full.29015fac.png";